<template>
  <transition name="fade">
    <div v-if="visible" :style='componentStyle' class="expression-editor-context-menu" @click.stop>
      <p>{{ $i18n.t('what_do_you_want_me_to_code?') }}</p>
      <el-input
        type="textarea"
        :placeholder="$i18n.t('expression_editor_prompt_example')"
        v-model="aiPrompt"
        :autosize="{ minRows: 4, maxRows: 4}"
        @change='onChange'
      >
      </el-input>
      <ai-button title='generate' @click='onAsk' />
    </div>
  </transition>
</template>

<script>
  import AiButton from './AiButton.vue'

  export default {
    name: 'AskAI',
    components: { AiButton },
    data(){
      return {
        aiPrompt: this.prompt
      }
    },
    props: {
      onAsk: {
        type: Function
      },
      prompt: {
        type: String,
        required: true
      },
      visible: {
        type: Boolean
      },
      componentStyle: {
        type: Object
      }
    },
    methods: {
      onChange(value){
        this.$emit('onChange', value)
      }
    }
  }
</script>

<style scoped lang='scss'>
  .expression-editor-context-menu p{
    color: $color-text-regular;
    font-weight: bold;
  }

  .expression-editor-context-menu{
    z-index: 100000000000;
    background-color: #fffffff2;
    border-radius: 1em;
    padding: 1em;
    min-height: 200px;
    min-width: 400px;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
    -webkit-transform: translate(-200px, 10px);
    transform: translate(-200px, 10px);
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }

  .expression-editor-context-menu textarea {
    margin-bottom: 1em;
  }
</style>